import {
  ExcelDataFormat,
  ExcelTable,
  excelTableFormatValue,
  excelTableToGridTemplateColumns,
} from "@app/hooks/useExcelExport";
import { CarInfoCell, CarInfoHeader, CarInfoTable } from "./InfoTable";
import { Fragment } from "react/jsx-runtime";
import { isOddEven } from "@app/utils";
import { BoxProps } from "@mui/material";

interface CarExcelTableProps {
  sx?: BoxProps["sx"];
  table: ExcelTable;
}

export const CarExcelTable = ({ sx, table }: CarExcelTableProps) => {
  return (
    <CarInfoTable
      sx={{
        gridTemplateColumns: excelTableToGridTemplateColumns(table),
        ...sx,
      }}
    >
      {table.columns.map((col, idx) => (
        <CarInfoHeader
          key={idx}
          text={col.label}
          pendoClass={col.pendoClassName}
          isSticky
        />
      ))}
      {table.rows.map((row, rowIdx) => (
        <Fragment key={rowIdx}>
          {row.map((val, valIdx) => (
            <CarInfoCell
              key={valIdx}
              isOdd={isOddEven(rowIdx)}
              justifyContent={
                table.columns.at(valIdx)?.format === ExcelDataFormat.general
                  ? "start"
                  : undefined
              }
              text={excelTableFormatValue(val, table.columns.at(valIdx))}
            />
          ))}
        </Fragment>
      ))}
    </CarInfoTable>
  );
};
